import { createContext } from 'react';

// Where the active tab's review controls render: a slot at the right end of the sticky
// step bar, so Approve and Flag stay in view however far the tab scrolls. Null outside the
// page (e.g. a section's own Storybook story), where the controls render in place instead.
export const ReviewControlsSlotContext = createContext<HTMLElement | null>(null);
